/**
 * Spinner. SPEC.md §19, §16.3.
 *
 * role="status" with a label, because a silent spinner tells a screen reader
 * nothing. It keeps a slow loop under prefers-reduced-motion — a frozen
 * indicator reads as a hung app — which index.css handles via the
 * data-reduced-motion-keep hook. §19
 */

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  size?: SpinnerSize;
  /** Announced to assistive tech; also the tooltip. */
  label?: string;
  className?: string;
}

const SIZES: Record<SpinnerSize, string> = {
  sm: 'size-4 border-2',
  md: 'size-6 border-2',
  lg: 'size-10 border-[3px]',
};

export function Spinner({ size = 'md', label = 'Loading…', className }: SpinnerProps) {
  const classes = [
    'inline-block shrink-0 animate-spin rounded-full',
    'border-current/25 border-t-current',
    SIZES[size],
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return <span role="status" aria-label={label} data-reduced-motion-keep className={classes} />;
}
